import { useEffect, useState } from 'react';

export function useDomRect(dom: HTMLElement | null) {
  const [rect, setRect] = useState<DOMRect | null>(null);

  useEffect(() => {
    if (dom) {
      setRect(dom.getBoundingClientRect());
    }
  }, [dom]);

  // whenever the dom is resized, update the rect
  useEffect(() => {
    if (dom) {
      const observer = new ResizeObserver(() => {
        setRect(dom.getBoundingClientRect());
      });
      observer.observe(dom);
      return () => observer.disconnect();
    }
  }, [dom]);

  return rect;
}
